import { render, staticRenderFns } from "./DetailsWarranty.vue?vue&type=template&id=397e0a7f&"
import script from "./DetailsWarranty.vue?vue&type=script&lang=js&"
export * from "./DetailsWarranty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports